const constants = require('@/util/constants')
require('./config')

/**
 * 邀请会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function invite (uids, tid, successcb, failedcb) {
  axios.post('/api/thread/invite', {
    uids: uids,
    tid: tid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 接受邀请会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function inviteAccept (tiid, successcb, failedcb) {
  axios.post('/api/thread/invite/accept', {
    tiid: tiid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 拒绝邀请会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function inviteReject (tiid, successcb, failedcb) {
  axios.post('/api/thread/invite/reject', {
    tiid: tiid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
